import React from 'react';
import { NavLink } from "react-router-dom";
import { useSelector} from "react-redux"

const Navbar = () => {

  const state = useSelector ((state) => state.handleCart)

  return (
    <nav className="navbar navbar-expand-lg bg-body-tertiary bg-dark border-bottom border-body py-3 shadow-sm" data-bs-theme="dark">
      <div className="container">

        <NavLink className="navbar-brand fw-bold fs-4" to="/">
          ShopEase
        </NavLink>

        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">

          <ul className="navbar-nav mx-auto mb-2 mb-lg-0">

            <li className="nav-item">
              <NavLink className="nav-link" activeClassName="active-link" exact to="/">Home</NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" activeClassName="active-link" to="/products">Products</NavLink>
            </li>
            
          </ul>

          <div className='button'>

            <NavLink to="/cart" className="btn btn-outline-success ms-2">
              <i className='fa fa-shopping-cart me-1'></i>
              Cart({state.length})
            </NavLink>

          </div>

        </div>
        
      </div>
    </nav>
  )
}

export default Navbar;
